import { render, staticRenderFns } from "./ServicesView.vue?vue&type=template&id=06bc13b2&"
import script from "./ServicesView.vue?vue&type=script&lang=ts&"
export * from "./ServicesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports